module.exports = __webpack_public_path__ + "img/yy1.ee6c2966.png";